<template>
  <div class="select">
    <div class="select-content">
      <!-- 赛事筛选 -->
      <div class="filter-row">
        <div class="filter-label">
          <i class="el-icon-trophy"></i>
          <span>赛事</span>
        </div>
        <div class="filter-options">
          <div
            class="filter-tag"
            v-for="(option, index) in matchList"
            :key="index"
            :class="{ active: selectedMatchIndex === index }"
            @click="selectMatch(option.name, index)">
            {{ option.label }}
          </div>
        </div>
      </div>

      <!-- 语言/分类筛选 -->
      <div class="filter-row">
        <div class="filter-label">
          <i class="el-icon-folder"></i>
          <span>语言</span>
        </div>
        <div class="filter-options">
          <div
            class="filter-tag"
            v-for="(langOption, index) in level2Options"
            :key="index"
            :class="{ active: selectedLangIndex === index }"
            @click="selectLang(langOption.name, index)">
            {{ langOption.label }}
          </div>
        </div>
      </div>

      <!-- 等级筛选 -->
      <div class="filter-row">
        <div class="filter-label">
          <i class="el-icon-medal"></i>
          <span>等级</span>
        </div>
        <div class="filter-options">
          <div
            class="filter-tag"
            v-for="(level, index) in level3Options"
            :key="index"
            :class="{ active: selectedLevelIndex === index }"
            @click="selectLevel(level, index)">
            {{ level }}
          </div>
        </div>
      </div>

      <!-- 更多筛选 -->
      <div class="filter-row filter-row-more">
        <div class="filter-label">
          <i class="el-icon-more"></i>
          <span>更多</span>
        </div>
        <div class="filter-controls">
          <!-- 免费/VIP 切换 -->
          <div class="vip-toggle" v-if="$route.path === '/testPaperCenter'">
            <div
              class="toggle-btn"
              :class="{ active: isActivePaperTypeFree }"
              @click="selectPaperType(0)">
              免费
            </div>
            <div
              class="toggle-btn vip"
              :class="{ active: isActivePaperTypeVip }"
              @click="selectPaperType(1)">
              VIP
            </div>
          </div>

          <!-- 年份选择 -->
          <el-date-picker
            class="custom-picker"
            v-if="$route.path !== '/wrongBook'"
            v-model="paperMonth"
            type="year"
            value-format="yyyy"
            @change="selectMonth"
            placeholder="选择年份"
            :picker-options="pickerOptions">
          </el-date-picker>

          <!-- 题型选择 -->
          <el-select
            v-model="selectedQuestionType"
            class="custom-picker has-prefix-icon"
            clearable
            v-if="$route.path === '/questionBank' || $route.path === '/wrongBook'"
            @change="selectByQuestionType"
            placeholder="选择题型">
            <i slot="prefix" class="el-icon-document-copy"></i>
            <el-option
              v-for="item in questionType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 日期选择 -->
          <el-date-picker
            class="custom-picker"
            v-if="$route.path === '/examinationRecord' || $route.path === '/wrongBook'"
            v-model="submitDate"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="selectDate"
            placeholder="选择日期">
          </el-date-picker>

          <!-- 搜索框 -->
          <el-input
            class="search-input"
            placeholder="搜索内容..."
            prefix-icon="el-icon-search"
            clearable
            v-model="selectContext"
            @input="handleInput"
            @keyup.enter.native="handleInput">
          </el-input>

          <!-- 重置按钮 -->
          <el-button
            class="reset-btn"
            @click="resetSelect">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainSelect",
  props: ['matchAndLang', 'selectPaperNameByHome'],
  data() {
    return {
      selectContext: '',
      paperYear: '',
      paperMonth: '',
      submitDate: '',
      selectedMatch: "ALL",
      selectedLang: "ALL",
      selectedLevel: "ALL",
      selectedMatchIndex: 0,
      selectedLangIndex: 0,
      selectedLevelIndex: 0,
      vipAnswer: null,
      isActivePaperTypeFree: false,
      isActivePaperTypeVip: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      matchList: [
        {index: 0, "label": "全部", "name": "ALL", "full_name": ""},
        {index: 1, "label": "电子学会", "name": "QCEIT", "full_name": "中国电子学会青少年等级考试"},
        {index: 2, "label": "CCF-GESP", "name": "CCF_GESP", "full_name": "GESP CCF编程能力等级认证"},
        {index: 3, "label": "信息学奥赛", "name": "NOI", "full_name": "全国青少年信息学奥林匹克竞赛"},
        {index: 4, "label": "蓝桥杯", "name": "LANQIAO", "full_name": "蓝桥杯全国软件和信息技术专业人才大赛"},
        {index: 6, "label": "信息素养", "name": "XXSY", "full_name": "全国青少年信息素养大赛"},
        {index: 5, "label": "NOC", "name": "NOC", "NOC": "全国中小学信息技术创新与实践大赛"},
        {index: 8, "label": "各校卷题", "name": "SCHOOL", "full_name": ""},
        {index: 9, "label": "CPA", "name": "CPA", "full_name": ""},
        {index: 10, "label": "人工智能AI", "name": "AI", "full_name": ""},
        {index: 7, "label": "其他", "name": "OTHER", "full_name": ""}
      ],
      langList: [],
      levelList: [],
      langOptionsMap: {
        "ALL": [
          {"label": "全部", "name": "ALL"},
          {"label": "图形化Scratch", "name": "Scratch"},
          {"label": "C/C++", "name": "C"},
          {"label": "Python", "name": "Python"},
          {"label": "机器人技术", "name": "ROBOT"}
        ],
        "QCEIT": [
          {"label": "全部", "name": "ALL"},
          {"label": "图形化", "name": "Scratch"},
          {"label": "C语言", "name": "C"},
          {"label": "Python", "name": "Python"},
          {"label": "机器人技术", "name": "ROBOT"}
        ],
        "CCF_GESP": [
          {"label": "全部", "name": "ALL"},
          {"label": "图形化", "name": "Scratch"},
          {"label": "C/C++", "name": "C"},
          {"label": "Python", "name": "Python"}
        ],
        "NOI": [
          {"label": "全部", "name": "ALL"},
          {"label": "专项训练", "name": "ZXXL"},
          {"label": "NOI", "name": "NOI"},
          {"label": "NOIP", "name": "NOIP"},
          {"label": "CSP-J", "name": "CSP-J"},
          {"label": "CSP-S", "name": "CSP-S"},
          {"label": "CSP-X", "name": "CSP-X"}
        ],
        "LANQIAO": [
          {"label": "全部", "name": "LANQIAO_ALL"},
          {"label": "Scratch", "name": "LANQIAO_Scratch"},
          {"label": "C/C++", "name": "LANQIAO_C"},
          {"label": "Python", "name": "LANQIAO_Python"},
          {"label": "科技素养", "name": "SY"},
          {"label": "计算思维", "name": "SW"}
        ],
        "NOC": [
          {"label": "全部", "name": "NOC_ALL"},
          {"label": "Scratch", "name": "NOC_Scratch"},
          {"label": "C/C++", "name": "NOC_C"},
          {"label": "Python", "name": "NOC_Python"}
        ],
        "XXSY": [
          {"label": "全部", "name": "XXSY_ALL"},
          {"label": "图形化编程", "name": "XXSY_Scratch"},
          {"label": "Python编程", "name": "XXSY_Python"},
          {"label": "C++算法创意实践", "name": "XXSY_C"}
        ],
        "SCHOOL": [
          {"label": "全部", "name": "ALL"},
          {"label": "Scratch", "name": "Scratch"},
          {"label": "C/C++", "name": "C"},
          {"label": "Python", "name": "Python"},
          {"label": "机器人技术", "name": "ROBOT"},
          {"label": "其他", "name": "SCHOOL_OTHER"},
        ],
        "OTHER": [
          {"label": "全部", "name": "ALL"},
          {"label": "算法竞赛", "name": "SF"},
          {"label": "上海月赛", "name": "SHANGHAI_MONTH"}
        ],
        "CPA": [
          {"label": "全部", "name": "ALL"},
          {"label": "图形化", "name": "Scratch"},
          {"label": "C++", "name": "C"},
          {"label": "Python", "name": "Python"},
        ],
        "AI": [
          {"label": "全部", "name": "ALL"},
          {"label": "Scratch", "name": "Scratch"},
          {"label": "C/C++", "name": "C"},
          {"label": "Python", "name": "Python"},
          {"label": "挑战赛", "name": "COMPETITION"},
        ],
      },
      levelOptionsMap: {
        "ALL": ["全部", "一级", "二级", "三级", "四级", "五级", "六级", "七级", "八级", "九级", "十级", "练习", "其他"],
        "Scratch": ["全部", "一级", "二级", "三级", "四级", "练习"],
        "C": ["全部", "一级", "二级", "三级", "四级", "五级", "六级", "七级", "八级", "九级", "十级", "练习", "其他"],
        "Python": ["全部", "一级", "二级", "三级", "四级", "五级", "六级", "七级", "练习"],
        "ROBOT": ["全部", "一级", "二级", "三级", "四级", "五级", "六级", "七级", "八级"],
        "NOI": ["全部"],
        "NOIP": ["全部", "普及组", "提高组", "其他"],
        "ZXXL": ["全部"],
        "CSP-J": ["全部"],
        "CSP-S": ["全部"],
        "CSP-X": ["全部", "初赛", "复赛", "决赛", "专项训练", "其他"],
        "XXSY_ALL": ["全部", "初赛", "复赛", "决赛", "专项训练", "其他"],
        "XXSY_Scratch": ["全部", "初赛", "复赛", "决赛", "专项训练", "其他"],
        "XXSY_Python": ["全部", "初赛", "复赛", "决赛", "专项训练", "其他"],
        "XXSY_C": ["全部", "初赛", "复赛", "决赛", "专项训练", "其他"],
        "NOC_ALL": ["全部", "初赛/选拔赛", "复赛", "决赛", "模拟练习", "其他"],
        "NOC_Scratch": ["全部", "初赛/选拔赛", "复赛", "决赛", "模拟练习", "其他"],
        "NOC_Python": ["全部", "初赛/选拔赛", "复赛", "决赛", "模拟练习", "其他"],
        "NOC_C": ["全部", "初赛/选拔赛", "复赛", "决赛", "模拟练习", "其他"],
        "SY": ["全部"],
        "SW": ["全部"],
        "SF": ["全部"],
        "SHANGHAI_MONTH": ["全部"],
        "LANQIAO_ALL": ["全部", "初级/选拔赛", "中级/省赛", "高级/国赛", "模拟练习", "其他"],
        "LANQIAO_Scratch": ["全部", "初级/选拔赛", "中级/省赛", "高级/国赛", "模拟练习", "其他"],
        "LANQIAO_C": ["全部", "一级/选拔赛", "二级/省赛", "三级/国赛", "模拟练习", "其他"],
        "LANQIAO_Python": ["全部", "初级/选拔赛", "中级/省赛", "高级/国赛", "模拟练习", "其他"],
        "SCHOOL": ["全部"],
        "SCHOOL_OTHER": ["全部"],
        "其他": ["全部"],
        "all": ["全部"],
        "AI_ALL": ["全部", "一级", "二级", "三级", "四级", "模拟练习"],
        "COMPETITION": ["全部"],
      },
      selectedQuestionType: null,
      questionType: [{
        value: 1000,
        label: '全部'
      }, {
        value: 0,
        label: '单选题'
      }, {
        value: 1,
        label: '判断题'
      }, {
        value: 4,
        label: '编程题'
      }, {
        value: 2,
        label: '多选题'
      }, {
        value: 3,
        label: '简答题'
      }, {
        value: 5,
        label: '填空题'
      }, {
        value: 99,
        label: '其他'
      }],
    }
  },
  methods: {
    resetSelect() {
      this.selectedMatch = "ALL";
      this.selectedMatchIndex = 0;
      this.selectedLang = 'ALL';
      this.selectedLangIndex = 0;
      this.selectedLevel = 'ALL';
      this.selectedLevelIndex = 0;
      this.paperName = '';
      this.paperMonth = null;
      this.submitDate = null;
      this.selectedQuestionType = null;
      this.$emit('reset-select');
    },
    handleInput() {
      this.$emit('new-select-context', this.selectContext);
    },
    selectMonth() {
      this.$emit('new-select-paper-month', this.paperMonth);
    },
    selectByQuestionType() {
      // 选择题型
      this.$emit('new-select-question-type', this.selectedQuestionType);
    },
    selectDate() {
      this.$emit('new-select-submit-date', this.submitDate);
    },
    selectMatch(option, index) {
      this.selectedMatch = option;
      this.selectedMatchIndex = index;
      if (option === "AI") {
        this.selectedLang = 'AI_ALL';
        this.selectedLangIndex = 0;
        this.selectedLevel = 'AI_ALL';
        this.selectedLevelIndex = 0;
      } else if (option === "NOI") {
        this.selectedLang = 'ALL';
        this.selectedLangIndex = 0;
        this.selectedLevel = 'ALL';
        this.selectedLevelIndex = 0;
      } else if (option === "LANQIAO") {
        this.selectedLang = 'LANQIAO_ALL';
        this.selectedLangIndex = 0;
        this.selectedLevel = 'LANQIAO_ALL';
        this.selectedLevelIndex = 0;
      } else if (option === "XXSY") {
        this.selectedLang = 'XXSY_ALL';
        this.selectedLangIndex = 0;
        this.selectedLevel = 'XXSY_ALL';
        this.selectedLevelIndex = 0;
      } else if (option === "NOC") {
        this.selectedLang = 'NOC_ALL';
        this.selectedLangIndex = 0;
        this.selectedLevel = 'NOC_ALL';
        this.selectedLevelIndex = 0;
      } else {
        this.selectedLang = 'ALL';
        this.selectedLangIndex = 0;
        this.selectedLevel = 'ALL';
        this.selectedLevelIndex = 0;
      }
      this.$emit('send-left-title-match', this.selectedMatchIndex);

      this.sendSelectedToParent();

    },
    selectLang(option, index) {
      this.selectedLang = option;
      this.selectedLangIndex = index;
      if (this.selectedMatch === "XXSY") {
        this.selectedLevel = 'XXSY_ALL';
        this.selectedLevelIndex = 0;
      }
      if (this.selectedMatch === "LANQIAO") {
        this.selectedLevel = 'LANQIAO_ALL';
        this.selectedLevelIndex = 0;
      }
      if (this.selectedMatch === "NOC") {
        this.selectedLevel = 'NOC_ALL';
        this.selectedLevelIndex = 0;
      }
      if (this.selectedLang === "SY" || this.selectedLang === "SW") {
        this.selectedLevel = 'ALL';
        this.selectedLevelIndex = 0;
      }
      if (this.selectedLang === "CSP-J" || this.selectedLang === "CSP-S") {
        this.selectedLevel = 'ALL';
        this.selectedLevelIndex = 0;
      }


      this.sendSelectedToParent();
    },
    selectLevel(option, index) {
      this.selectedLevel = option;
      this.selectedLevelIndex = index;
      this.sendSelectedToParent();
    }
    ,
    selectPaperType(paperType) {
      //paperType 0:免费 1：会员
      if (paperType === 1) {
        this.isActivePaperTypeVip = !this.isActivePaperTypeVip;
        this.isActivePaperTypeFree = false;
        if (this.isActivePaperTypeVip) {
          this.vipAnswer = 1;
        } else {
          this.vipAnswer = null;
        }
      } else {
        this.isActivePaperTypeFree = !this.isActivePaperTypeFree;
        this.isActivePaperTypeVip = false;
        if (this.isActivePaperTypeFree) {
          this.vipAnswer = 0;
        } else {
          this.vipAnswer = null;
        }
      }
      this.$emit('select-paper-type', this.vipAnswer);
    }
    ,
    //选择分类，同步父级
    sendSelectedToParent() {
      const data = {
        selectedMatch: this.selectedMatch,
        selectedLang: this.selectedLang,
        selectedLevel: this.selectedLevel
      };
      this.$emit('send-selected-to-parent', data);
    }

  },

  watch: {
    matchAndLang: {
      handler(object) {
        if (object != null) {

          if (object.matchIndex != null && object.matchIndex !== '') {
            this.selectedMatchIndex = object.matchIndex;
            this.selectedMatch = object.matchName;
          }

          if (object.langIndex != null && object.langIndex !== '') {
            this.selectedLang = object.langName;
            this.selectedLangIndex = object.langIndex;
          }

          if (object.levelIndex != null && object.levelIndex !== '' && object.levelIndex !== 'undefine') {
            this.selectedLevel = object.levelName;
            this.selectedLevelIndex = object.levelIndex;
          }
          this.sendSelectedToParent();
        }
      },
      deep: true
    },
    selectPaperNameByHome: {
      handler: function (n, o) {
        this.selectContext = n

      }
    }
  },
  computed: {
    level2Options() {
      return this.selectedMatch ? this.langOptionsMap[this.selectedMatch] : [];
      // return this.selectedMatch ? this.langOptionsMap[this.selectedMatch] : [];
    },
    level3Options() {
      return this.selectedLang ? this.levelOptionsMap[this.selectedLang] : [];
    }
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener('scroll', this.handleScrollx, true);
  }
}
</script>

<style lang="scss" scoped>
// 主色调变量
$primary-color: #0080FF;
$primary-light: #E7F3FF;
$text-primary: #303133;
$text-secondary: #606266;
$text-muted: #909399;
$border-color: #EBEEF5;
$bg-light: #F5F7FA;
$shadow-light: 0 2px 12px rgba(0, 0, 0, 0.06);
$shadow-hover: 0 4px 16px rgba(64, 158, 255, 0.15);

.select {
  width: 100%;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 16px;
  box-shadow: $shadow-light;
  overflow: hidden;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: $shadow-hover;
  }

  .select-content {
    padding: 20px 24px;
  }
}

// 筛选行样式
.filter-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dashed $border-color;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
}

// 标签样式
.filter-label {
  display: flex;
  align-items: center;
  min-width: 60px;
  padding-right: 8px;
  color: $text-secondary;
  font-size: 13px;
  font-weight: 500;
  flex-shrink: 0;

  i {
    margin-right: 4px;
    font-size: 14px;
    color: $primary-color;
  }

  span {
    white-space: nowrap;
  }
}

// 选项容器
.filter-options {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  flex: 1;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

// 筛选标签
.filter-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: 13px;
  flex-shrink: 0;
  color: #333;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    color: $primary-color;
    background: $primary-light;
  }

  &.active {
    color: $primary-color;
    background: $primary-light;
  }
}

// 更多筛选行
.filter-row-more {
  .filter-controls {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    flex: 1;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

// VIP切换按钮组
.vip-toggle {
  display: flex;
  gap: 8px;

  .toggle-btn {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    font-size: 13px;
    color: #333;
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;

    i {
      margin-right: 4px;
      font-size: 14px;
    }

    &:hover {
      color: $primary-color;
      background: $primary-light;
    }

    &.active {
      color: $primary-color;
      background: $primary-light;
    }
  }
}

// 自定义选择器样式
.custom-picker {
  width: 120px;
  flex-shrink: 0;

  ::v-deep .el-input__inner {
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    border-color: $border-color;
    font-size: 13px;
    padding-left: 30px;
    padding-right: 30px;
    transition: all 0.25s ease;

    &:hover {
      border-color: $primary-color;
    }

    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
    }
  }

  ::v-deep .el-input__prefix {
    left: 8px;
  }

  ::v-deep .el-input__suffix {
    right: 8px;
  }

  ::v-deep .el-input__icon {
    line-height: 34px;
  }
}

// 带前缀图标的选择器
.has-prefix-icon {
  ::v-deep .el-input__prefix {
    display: flex;
    align-items: center;
    left: 8px;
    color: $text-muted;
  }
}

// 搜索输入框
.search-input {
  width: 220px;
  flex-shrink: 0;

  ::v-deep .el-input__inner {
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    border-color: $border-color;
    font-size: 13px;
    padding-left: 36px;
    transition: all 0.25s ease;

    &::placeholder {
      color: $text-muted;
    }

    &:hover {
      border-color: $primary-color;
    }

    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
    }
  }

  ::v-deep .el-input__prefix {
    left: 12px;
  }

  ::v-deep .el-input__icon {
    line-height: 34px;
    color: $text-muted;
  }
}

// 重置按钮
.reset-btn {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 13px;
  color: $text-secondary;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  i {
    margin-right: 4px;
    font-size: 14px;
  }

  &:hover {
    color: $primary-color;
    background: $primary-light;
  }
}

</style>
